module.exports = __webpack_public_path__ + "static/media/img6.4879c653.jpeg";